import InputBox from "@/components/Form/InputBox/InputBox";
import { getCommonCopyImg } from "@/components/Images/CommonImages";
import CommonTooltipWrapper from "@/components/Tooltip/CommonTooltipWrapper";
import { MotifIconButton, MotifToast } from "@ey-xd/motif-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CopyInputBox = ({
  value,
  isReadonly,
  label,
}: {
  value: string;
  isReadonly: boolean;
  label: string;
}) => {
  const { t } = useTranslation();
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    supportingMessage: "",
    type: "success",
  });
  const renderMessage = () => {
    if (notification.show) {
      return (
        <MotifToast
          className="toast-con-property"
          position="top"
          onClose={() => {
            setNotification({
              ...notification,
              show: false,
              message: "",
              type: "success",
            });
          }}
          //@ts-ignore
          variant={notification.type}
        >
          {t(notification.message)}
        </MotifToast>
      );
    }
  };
  useEffect(() => {
    let clearTime = setTimeout(() => {
      setNotification({
        ...notification,
        show: false,
        message: "",
        type: "success",
      });
    }, 800);
    return () => {
      clearTimeout(clearTime);
    };
  });
  const copiedToClipBoard = (
    event: React.MouseEvent<HTMLButtonElement>,
    executionLog: any
  ) => {
    event.stopPropagation();
    setNotification({
      ...notification,
      show: false,
      message: "",
      type: "success",
    });
    navigator.clipboard
      .writeText(executionLog)
      .then(() => {
        setNotification({
          ...notification,
          show: true,
          message: t("global.globalNotifications.globalCopiedToClipboard", {
            labelName: label,
          }),
          type: "success",
        });
      })
      .catch((err) => {
        setNotification({
          ...notification,
          show: true,
          message: t(
            "global.globalNotifications.globalCopiedToClipboardError",
            { labelName: label }
          ),
          type: "error",
        });
      });
  };
  return (
    <>
      {renderMessage()}
      {/* <MotifToast  className='toastCss'  position='top' variant='error'  >gokul</MotifToast> */}

      <div className="form-field">
        <div className="display-flex justify-content-between">
          <div className="formFieldLabel">
            <label htmlFor="input">{label}</label>
          </div>
          {value && (
            <CommonTooltipWrapper
              tooltipTitle={t("global.globalActions.copyToClipboard")}
            >
              <MotifIconButton
                size="small"
                onClick={(event: any) => copiedToClipBoard(event, value)}
                type="button"
              >
                {getCommonCopyImg()}
              </MotifIconButton>
            </CommonTooltipWrapper>
          )}
        </div>
        {value ? (
          <InputBox
            style={{ cursor: "default" }}
            disabled={isReadonly}
            onChange={() => {}}
            value={value}
            isTextArea={true}
          ></InputBox>
        ) : (
          <div className="motif-body2-default-bold">-</div>
        )}
      </div>
    </>
  );
};

export default CopyInputBox;
